import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueResource from 'vue-resource';
Vue.use(VueResource)
Vue.config.productionTip = false;
// 挂载静态图片
import $mAssetsPath from '@/common/assets.config.js';
Vue.prototype.$mAssetsPath = $mAssetsPath;
// 配置环境变量
import $mConfig from '@/common/index.config.js';
Vue.prototype.$mConfig = $mConfig;
// 挂载全局js
import $GLOBAL from '@/common/global.js';
Vue.prototype.$GLOBAL = $GLOBAL;
import $mUtil from '@/common/util.js';
Vue.prototype.$mUtil = $mUtil;
// import $mChecker from '@/common/graceChecker.js';
// Vue.prototype.$mChecker = $mChecker;

// 挂载懒加载
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);

import VueClipBoard from 'vue-clipboard2'

Vue.use(VueClipBoard)
// 挂载全局的页面
import myFoot from '@/components/publicComponents/tabbar.vue';
Vue.component("myFoot", myFoot);
import backTop from '@/components/publicComponents/backTop.vue';
Vue.component("backTop", backTop);
import noneData from '@/components/publicComponents/noneData.vue';
Vue.component("noneData", noneData);
import mPageView from "@/components/publicComponents/m-page-view.vue";
Vue.component("joy-page", mPageView);
import Share from '@/components/publicComponents/Share.vue';
Vue.component("Share", Share);
import Subsite from '@/components/publicComponents/Subsite.vue';
Vue.component("Subsite", Subsite);

// 挂载axios
import axios from './http';
Vue.prototype.$axios = axios;
// 全局挂载store
Vue.prototype.$store = store;
// 微信sdk
import $wx from 'weixin-js-sdk';
Vue.prototype.$wx = $wx;

// vant全局css
import 'vant/lib/index.css';
// 自动布局css
import 'lib-flexible';

import lrz from 'lrz';
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)
import qqmap from './common/geolocation.min'
// 配置vant组件
import {
  Card,
  Row,
  Col,
  Icon,
  Grid,
  Tabbar,
  TabbarItem,
  GridItem,
  Button,
  Field,
  Cell,
  CellGroup,
  SwipeCell,
  CouponCell,
  CouponList,
  Popup,
  SubmitBar,
  Radio,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  Picker,
  Toast,
  Dialog,
  Sku,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  RadioGroup,
  Swipe,
  SwipeItem,
  Sticky,
  Search,
  Tab,
  Tabs,
  List,
  Image,
  Panel,
  Uploader,
  ActionSheet,
  Tag,
  Step,
  Steps,
  Skeleton,
  Loading,
  CountDown,
  Progress,
  NavBar,
  ContactCard,
  ContactList,
  ContactEdit,
  AddressEdit,
  AddressList,
  Area,
  DropdownMenu,
  DropdownItem,
  PullRefresh,
  ImagePreview,
  Overlay,
  Switch,
  Collapse,
  CollapseItem,
  Divider,
  Empty,
  Badge,
  NoticeBar
} from 'vant';
Vue.use(NoticeBar);
Vue.use(Badge);
Vue.use(Empty);
Vue.use(Card);
Vue.use(Row);
Vue.use(Col);
Vue.use(Icon);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Button);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(SwipeCell);
Vue.use(CouponCell);
Vue.use(CouponList);
Vue.use(Popup);
Vue.use(SubmitBar);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Sku);
Vue.use(GoodsAction);
Vue.use(GoodsActionIcon);
Vue.use(GoodsActionButton);
Vue.use(RadioGroup);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Sticky);
Vue.use(Search);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);
Vue.use(Image);
Vue.use(Panel);
Vue.use(Uploader);
Vue.use(ActionSheet);
Vue.use(Tag);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Skeleton);
Vue.use(Loading);
Vue.use(CountDown);
Vue.use(Progress);
Vue.use(NavBar);
Vue.use(ContactCard);
Vue.use(ContactList);
Vue.use(ContactEdit);
Vue.use(AddressEdit);
Vue.use(AddressList);
Vue.use(Area);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(PullRefresh);
Vue.use(ImagePreview);
Vue.use(Overlay);
Vue.use(Switch);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Divider);
Vue.use(Tabbar);
Vue.use(TabbarItem);

Vue.prototype.wxShare = function (config) {
  let title = "";
  let desc = "";
  let img = "";
  let link = "";
  let href = window.location.href;
  let origin = window.location.origin;
  if (!config) {
    title = "假日伙伴招募";
    desc = "浙江皓石教育科技有限公司旗下招募系统";
    img = "http://img.jiarixiaodui.com/logo.jpg";
    link = 'https://jrhb.jiarixiaodui.com/?#/';
  } else {
    title = config.title;
    desc = config.desc || '浙江皓石教育科技有限公司旗下招募系统';
    img = config.img || "http://img.jiarixiaodui.com/logo.jpg";
    let fakeLink = href.split("#");
    if (config.sharePath) {
      link = fakeLink[0] + "#" + config.sharePath;
    } else {
      link = href.split('#')[0] + '#' + href.split('#')[1];
    }
    console.log('----------------------------------------');
    console.log(img, 'link');
    console.log('----------------------------------------');
  };
  const url = "https://api.jiarixiaodui.com/v1/wx/config?url=" + link;

  this.$axios.get(url).then(res => {
    let data = res.data;
    $wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: data.appId, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.nonceStr, // 必填，生成签名的随机串
      signature: data.signature, // 必填，签名，见附录1
      jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", 'hideMenuItems']
    });
    // console.log('分享的接口url是', url, 'shareUrl原始链接是', origin + '/html/redirect.html?app3Redirect=' + link, '----------', title, desc, img);
    $wx.ready(function () {

      let shareUrl = origin + '/html/redirect.html?app3Redirect=' + encodeURIComponent(link);

      //获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）
      $wx.onMenuShareAppMessage({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: shareUrl, // 分享链接
        imgUrl: img, // 分享图标
      });
      //获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）
      $wx.onMenuShareTimeline({
        desc: desc, // 分享描述
        title: title, // 分享标题
        link: shareUrl, // 分享链接
        imgUrl: img, // 分享图标
      });

    });
  });
};
Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份 
    "d+": this.getDate(), //日 
    "H+": this.getHours(), //小时 
    "m+": this.getMinutes(), //分 
    "s+": this.getSeconds(), //秒 
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
    "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
//全局函数检查是否已经登录
Vue.prototype.checkLogin = function () {
  console.log('进来了checkLogin')
  let token = window.localStorage.token;
  if (!token) {
    this.$toast('请先登录');
    localStorage.redirectUrl = this.$router.currentRoute.fullPath;
    setTimeout(() => {
      router.replace({
        path: '/WxLogin'
      })
    }, 1000);
    return false;
  }
  return true;
};

Vue.prototype.isWeixin = function () {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}




new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')